<template>
    <div v-show="show" :class="wrapperCssClass">
        <textarea
                :name="name"
                :id="id"
                :maxlength="maxlength"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                :class="invalidClass"
                :style="cssStyle"
                :value="value"
                @input="update($event.target.value)"
                v-focus="focus"
        ><slot></slot></textarea>
    </div>
</template>
<script>
    import TextInput from '../../../mixins/Form/TextInput.vue';

    export default {
        mixins: [TextInput],
        mounted() {
            let value = this.$slots.default ? this.$slots.default[0].text : '';
            this.update(value);
        },
    };
</script>
